<div class="boxWhite">
  <h4>IMPORTAR</h4>

  <button class="btn btnClose" (click)="close()">
    <img src="assets/img/icoClose.svg" alt="">
  </button>

  <div class="contModal" *ngIf="!requiereConfirmacion">
    <div class="mb-4">
      <h6 class="clBlack">Fecha a importar</h6>
      <input type="text" class="form-control" placeholder="SELECCIONE FECHA" bsDatepicker
        (bsValueChange)="onChangeFecha($event)" [bsConfig]="{dateInputFormat: 'DD-MM-YYYY'}"
        [bsValue]="fechaImportar">
    </div>

    <div class="fechaLegible">
      {{fechaLegible}}
    </div>

    <div class="mb-4">
      <h6 class="clBlack">Tipo de importación</h6>
      <div class="radio-group">
        <label class="radio-option">
          <input type="radio" name="tipoImportacion" value="solo_jornadas" [(ngModel)]="tipoImportacion">
          <span>Solo jornadas</span>
        </label>
        <label class="radio-option">
          <input type="radio" name="tipoImportacion" value="ambos" [(ngModel)]="tipoImportacion">
          <span>Jornadas y viajes</span>
        </label>
        <label class="radio-option">
          <input type="radio" name="tipoImportacion" value="solo_viajes" [(ngModel)]="tipoImportacion">
          <span>Solo viajes</span>
        </label>
      </div>
    </div>
  </div>

  <div class="contModal" *ngIf="requiereConfirmacion">
    <div class="mensajeConfirmacion">
      <img src="assets/img/icoWarning.svg" alt="" class="icoWarning" *ngIf="false">
      <p class="textoAdvertencia">{{mensajeConfirmacion}}</p>
      <p class="fechaFormateada">{{fechaFormateada}}</p>
      <p class="fechaConfirmar">{{fechaLegible}}</p>
    </div>
  </div>

  <div class="footModal" *ngIf="!requiereConfirmacion">
    <button class="btn btnOrange w-100" (click)="ejecutar()" [disabled]="importando">
      {{importando ? 'IMPORTANDO...' : 'CONFIRMAR IMPORTACIÓN'}}
    </button>
  </div>

  <div class="footModal footConfirmacion" *ngIf="requiereConfirmacion">
    <button class="btn btnGray" (click)="cancelarConfirmacion()">CANCELAR</button>
    <button class="btn btnOrange" (click)="confirmar()" [disabled]="importando">
      {{importando ? 'IMPORTANDO...' : 'SÍ, IMPORTAR'}}
    </button>
  </div>
</div>
